export default {
  nokids: {
    label: 'Alleinlebene und Paare ohne Kind',
    entries: [
      {
        gender: 'Männer',
        paid: 30.00,
        unpaid: 18.07,
      },
      {
        gender: 'Frauen',
        paid: 24.30,
        unpaid: 24.78,
      },
    ]
  },
  withkids: {
    label: 'Alleinerziehende und Paare mit Kind(ern)',
    entries: [
      {
        gender: 'Männer',
        paid: 37.28,
        unpaid: 22.15,
      },
      {
        gender: 'Frauen',
        paid: 17.37,
        unpaid: 39.83,
      },
    ]
  },
}
